export class Abonent {
  contract_name___ru: string;
  contract_name___kz: string;
  contract_bin: string;
  contract_bank_name___ru: string;
  contract_bank_name___kz: string;
  contract_bank_number: string;
  is_resident: boolean;
  contract_kbe___ru: string;
  contract_kbe___kz: string;
  contract_knp: string;
  contractor_country_name___ru: string;
  contractor_country_name___kz: string;
  district_name___ru: string;
  district_name___kz: string;
  contractor_real_address___ru: string;
  contractor_real_address___kz: string;
  receiver_name___ru: string;
  receiver_name___kz: string;
  contract_address___ru: string;
  contract_address___kz: string;
  contract_post_index: string;
  contract_nds_date: Date;
  contractor_tax_branch_name___ru: string;
  contractor_tax_branch_name___kz: string;
  nds_series: string;
  nds_number: string;
  contract_first_job_pos_type___ru: string;
  contract_first_job_pos_type___kz: string;
  contract_first_name: string;
  contract_finance_first_job_pos_type___ru: string;
  contract_finance_first_job_pos_type___kz: string;
  contract_finance_first_name: string;
  contract_phone: string;
  contract_email: string;
  contract_fax: string;
}
